import type { ServerOptions } from 'vue3-easy-data-table'
import { ref, watch, type Ref } from 'vue'
import { INVENTORY_ROWS_PER_PAGE } from '@/const/Inventory'

type LoadOptions = {
  page: number
  rowsPerPage: number
}

export const useInventoryServerPagination = (
  companyId: Ref<string>,
  onLoad: (options: LoadOptions) => void | Promise<void>,
) => {
  const serverOptions: Ref<ServerOptions> = ref({
    page: 1,
    rowsPerPage: INVENTORY_ROWS_PER_PAGE,
  })
  const lastCompanyId = ref(companyId.value)

  const updateServerOptions = (newOptions: ServerOptions) => {
    serverOptions.value = newOptions
  }

  const resetPagination = () => {
    serverOptions.value.page = 1
  }

  const loadFromServer = () => {
    if (!companyId.value) return
    onLoad({
      page: serverOptions.value.page,
      rowsPerPage: serverOptions.value.rowsPerPage,
    })
  }

  watch(
    () => [companyId.value, serverOptions.value.page, serverOptions.value.rowsPerPage],
    ([nextCompanyId, page]) => {
      if (!nextCompanyId) return
      if (nextCompanyId !== lastCompanyId.value) {
        lastCompanyId.value = nextCompanyId
        resetPagination()
        if (page !== 1) return
      }
      loadFromServer()
    },
    { immediate: true },
  )

  return {
    serverOptions,
    updateServerOptions,
    resetPagination,
    resetAndReload: () => {
      resetPagination()
      loadFromServer()
    },
  }
}
